import Tab from "components/Tab";
import Beta from "../../../../contents/docs/workflows/_snippets/beta.mdx";
import AddSlackToWorkspace from "../../../../contents/docs/workflows/_snippets/add-posthog-to-slack-workspace.mdx";
import AddSlackToChannel from "../../../../contents/docs/workflows/_snippets/add-posthog-to-slack-channel.mdx";
import * as React from 'react';
export default {
  Tab,
  Beta,
  AddSlackToWorkspace,
  AddSlackToChannel,
  React
};